<script setup>

import LandingPageNavBarV2 from '@/components/navigation/LandingPageNavigationBarV2.vue';
import ContactFormV2 from '@/components/forms/ContactFormV2.vue';
import SharedBackground from '@/components/layout/SharedBackground.vue';
</script>

<template>
  <SharedBackground />
  <div class="relative z-10">
    <LandingPageNavBarV2 />
    <ContactFormV2 />
  </div>
</template>

<style scoped></style>
